import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IReportContextValue } from '../../models/comodel/mergefieldsmodel.model';

import {Reminder, ReminderType} from "../models/reminders.model";

@Injectable()
export class RemindersService {

  constructor(public http: HttpClient) { }

  getAll(): Observable<Reminder[]> {
    return this.http.get<Reminder[]>("/api/reminders");
  }

  get(id: string): Observable<Reminder> {
    return this.http.get<Reminder>(`/api/reminders/${id}`);
  }

  post(item: Reminder) : Observable<any>{
    return this.http.post(`/api/reminders/${item.id}`,item);
  }

  // execute(id:string, asOfDate:Date): Observable<any>{
  //   return this.http.post<string>(`/api/reminders/${id}/execute?asOfDate=${asOfDate}`,"");
  // }

  delete(id:string) : Observable<any>{
      return this.http.delete(`/api/reminders/${id}`);
  }

  generateAllActiveReminders(): Observable<any> {
    return this.http.get(`/api/schedule/generateReminders`);
  }

  getReminderTypeMergeFields(reminderType: ReminderType): Observable<IReportContextValue[]> {
    return this.http.get<IReportContextValue[]>(`/api/reminders/fetchReminderMergeFields/${reminderType}`);
  }

}
